var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.624 113.231C102.596 112.275 101.793 111.536 100.845 111.399C95.3795 110.609 91.5895 105.536 92.3802 100.071C93.1709 94.6046 98.2429 90.8145 103.709 91.6052C109.175 92.396 112.965 97.468 112.174 102.934C112.161 103.023 112.147 103.112 112.132 103.2C111.945 104.288 112.435 105.447 113.464 105.847C114.494 106.247 115.669 105.737 115.917 104.66C116.004 104.282 116.076 103.897 116.133 103.507C117.24 95.8543 111.934 88.7534 104.282 87.6465C96.6292 86.5395 89.5284 91.8455 88.4214 99.4979C87.3144 107.15 92.6205 114.251 100.273 115.358C100.413 115.378 100.553 115.396 100.692 115.412C101.791 115.538 102.665 114.602 102.632 113.497L102.624 113.231Z",
    fill: "#CBBBF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.247 86.131C122.356 86.7841 121.111 86.585 120.386 85.7513C116.744 81.5608 111.639 78.607 105.714 77.7498C92.5953 75.8521 80.4224 84.9482 78.5248 98.0665C77.3456 106.218 80.4113 114.004 86.0492 119.187C86.8619 119.934 87.0273 121.184 86.351 122.057C85.6739 122.931 84.4108 123.095 83.5883 122.356C76.8555 116.311 73.1734 107.121 74.566 97.4938C76.7799 82.1891 90.9816 71.577 106.286 73.791C113.318 74.8082 119.359 78.356 123.621 83.3788C124.336 84.2211 124.138 85.478 123.247 86.131Z",
    fill: "#E5DDFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.596 77.8696C133.706 78.5473 132.436 78.3577 131.729 77.4901C125.923 70.3651 117.531 65.3139 107.718 63.8943C86.9472 60.8896 67.6735 75.2917 64.6688 96.0624C62.1119 113.738 72.1604 130.329 88.0119 136.733C89.0095 137.136 89.5705 138.223 89.2596 139.253C88.9315 140.34 87.7646 140.941 86.71 140.522C69.0747 133.502 57.8733 115.1 60.71 95.4897C64.031 72.5327 85.3335 56.6145 108.29 59.9355C119.212 61.5153 128.54 67.1648 134.962 75.126C135.646 75.9739 135.463 77.2099 134.596 77.8696Z",
    fill: "#CBBBF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.079 155.332C105.977 154.25 105.032 153.451 103.946 153.485C100.949 153.577 97.9026 153.411 94.8324 152.967C66.4095 148.855 46.7013 122.481 50.8129 94.0578C54.9246 65.6348 81.2991 45.9266 109.722 50.0383C123.441 52.0228 135.129 59.1938 143.089 69.2782C143.774 70.1456 145.022 70.344 145.915 69.6924C146.807 69.0414 147.005 67.7885 146.323 66.92C137.749 55.9964 125.123 48.2246 110.295 46.0795C79.6853 41.6516 51.282 62.8758 46.8541 93.4851C42.4262 124.094 63.6504 152.498 94.2597 156.926C97.6172 157.411 100.948 157.588 104.224 157.478C105.347 157.441 106.183 156.451 106.079 155.332Z",
    fill: "#E5DDFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.977 167.135C119.671 166.089 118.587 165.483 117.527 165.735C109.661 167.604 101.317 168.05 92.8284 166.822C56.7531 161.604 31.7388 128.128 36.9575 92.0532C42.1761 55.9779 75.6514 30.9637 111.727 36.1823C129.375 38.7352 144.376 48.0505 154.485 61.1244C155.161 61.9988 156.411 62.1988 157.304 61.5483C158.197 60.8988 158.397 59.6472 157.723 58.7729C147 44.8565 131.06 34.9374 112.299 32.2235C74.0377 26.6886 38.5336 53.2189 32.9987 91.4805C27.4638 129.742 53.9941 165.246 92.2557 170.781C101.301 172.09 110.193 171.606 118.571 169.599C119.661 169.338 120.291 168.211 119.977 167.135Z",
    fill: "#E5DDFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.697 44.9868C178.358 45.8716 178.177 47.1249 177.292 47.7861L114.401 94.7808C113.517 95.442 112.263 95.2607 111.602 94.3759C110.941 93.4911 111.122 92.2378 112.007 91.5766L174.898 44.5818C175.783 43.9206 177.036 44.1019 177.697 44.9868Z",
    fill: "#CBBBF7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 49,
    r: 6,
    fill: "#E5DDFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 128,
    r: 6,
    fill: "#E5DDFB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 101.5,
    r: 5.5,
    fill: "#E5DDFB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 109,
    r: 6,
    fill: "#E5DDFB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 157,
    r: 6,
    fill: "#CBBBF7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 115,
    r: 6,
    fill: "#CBBBF7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImage);
export default __webpack_public_path__ + "static/media/main_image.cd5fc5822480120ff5a21b0e41084081.svg";
export { ForwardRef as ReactComponent };